<template>
  <div class="parent-goal-bar text-medium-1 text-secondary">
    <b-button
      @click="openParentGoalModal = true"
      variant="link"
      class="text-secondary py-0 row-data text-medium-1 border-0 choose-parent"
      v-if="parentGoalsCount === 0"
      >Align to parent goals</b-button
    >
    <div class="row-data d-flex align-items-center" v-else>
      <i class="goal-greyed-thick-icon flex-shrink-0"></i>
      <span class="show-alignments ml-2 pointer" id="show-parent-goals" v-if="parentGoalsCount > 1"
        >Aligns to {{ parentGoalsCount }} goals</span
      >
      <template v-else-if="parentGoal">
        <b-button
          @click="openParentGoal($event, parentGoal)"
          variant="link"
          class="text-secondary p-0 ml-2 row-data text-medium-1 border-0 text-truncate"
          :title="parentGoal.title"
          v-no-capture
          >{{ parentGoal.title }}</b-button
        >
      </template>
    </div>
    <parent-goals-alignment
      :org-id="goal.organizationId"
      :sub-org-id="subOrgId"
      :goal="goal"
      :save-on-submit="true"
      v-model="openParentGoalModal"
      v-if="openParentGoalModal"
    />
    <parent-goals-popover v-if="parentGoalsCount > 1" target="show-parent-goals" :goal="goal" />
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import ParentGoalsPopover from '@/components/goal/ParentGoalsPopover'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import TeamMixin from '@/mixins/TeamMixin'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getGoalPageRouteConfig } from '@/utils/navigationConfigs'
import { BButton } from 'bootstrap-vue'
import { ROUTE_NAMES } from '@/constants/routes'
import { mapActions } from 'vuex'
import ParentGoalsAlignment from '@/components/goal/ParentGoalsAlignment'

/**
 * This shows Parent Goals of a goal (prop - goalId). If parent goal is not available, it gives an option to  set parent goals
 */
export default {
  name: 'ParentGoalsBar',
  props: ['goalId'],
  mixins: [TeamMixin],
  data() {
    return {
      ROUTE_NAMES: ROUTE_NAMES,
      openParentGoalModal: false,
      parentGoal: null
    }
  },
  components: {
    BButton,
    ParentGoalsAlignment,
    ParentGoalsPopover
  },
  computed: {
    parentGoalsCount() {
      return this.goal.parentGoalIds?.length ?? 0
    },
    goal() {
      return this.$store.getters.goalById(this.goalId)
    },
    subOrgId() {
      return this.getClosestOrgLikeTeamId(this.goal.teamId)
    }
  },
  methods: {
    ...mapActions(['getGoal']),
    openParentGoal(event, goal) {
      const location = getGoalPageRouteConfig({
        orgId: goal.organizationId,
        goalId: goal.id
      })
      handleClickNavigation.call(this, event, location, true)
      trackEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.CHANGE_ALIGNMENT, EVENT_NAME.GOAL_PAGE)
    },
    async refreshParentGoal() {
      if (this.parentGoalsCount === 1) {
        this.parentGoal = await this.getGoal({
          orgId: this.goal.organizationId,
          goalId: this.goal.parentGoalIds[0]
        })
      }
    }
  },
  mounted() {
    this.refreshParentGoal()
  },
  watch: {
    parentGoalsCount: 'refreshParentGoal'
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
.parent-goal-bar {
  padding-left: 36px;
  padding-right: 70px;
  padding-top: 25px;
}
.row-data {
  line-height: 18px;
}
.choose-parent {
  opacity: 0;
  padding-left: 35px;
  /*
  This element is shown when user hovers topbar of goalviwer
   */
  transition: opacity ease-out 150ms;
}
.show-alignments {
  padding: 3px 6px;
  border: 1px solid $borderPrimary;
  border-radius: 5px;
}
.goal-greyed-thick-icon {
  position: relative;
  &:after {
    position: absolute;
    content: '';
    width: 1px;
    height: 14px;
    display: inline-block;
    background-color: $tertiary;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
  }
}
@include media-breakpoint-down(md) {
  .parent-goal-bar {
    padding-left: 0;
    padding-right: 8px;
  }
}
</style>
